import { message, Spin } from "antd"
import * as API from "common/api"
import * as COMMONS from "common/common"
import React from "react"
import { Helmet } from "react-helmet-async"
import { useMutation, useQuery } from "react-query"
import { useNavigate, useLocation } from "react-router-dom"
import { parse } from "query-string"

const Login = (props) => {
  const navigate = useNavigate()
  const queryParams = parse(useLocation().search)

  const smaregiLoginMutation = useMutation(API.SMAREGI_LOGIN, {
    onSuccess: (response) => {
      message.success(COMMONS.SUCCESS_LOGIN_MSG)
      navigate(COMMONS.ADMIN_SHIPMENTS_ROUTE)
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  useQuery(API.QUERY_KEY_ADMIN_CHECK_SESSION, API.ADMIN_CHECK_SESSION, {
    onSuccess: () => {
      navigate(COMMONS.ADMIN_SHIPMENTS_ROUTE)
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        if (queryParams?.code) {
          const data = {
            authorizationCode: queryParams.code,
          }

          smaregiLoginMutation.mutate(data)
        } else {
          window.location.href = `${API.SMAREGI_URL}?response_type=${API.SMAREGI_RESPONSE_TYPE}&client_id=${API.SMAREGI_CLIENT_ID}&scope=${API.SMAREGI_SCOPE}&state=${API.SMAREGI_STATE}&redirect_uri=${API.SMAREGI_REDIRECT_URI}`
        }
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  return (
    <>
      <Helmet>
        <title>{process.env.REACT_APP_SYSTEM_NAME}</title>
      </Helmet>
      <div className="flex h-screen">
        <div className="w-11/12 sm:w-1/2 md:w-1/2 lg:w-1/3 p-6 m-auto z-10 bg-white rounded-lg drop-shadow animate__animated animate__fadeIn">
          <Spin
            spinning={true}
            tip={<p className="text-xl font-bold">確認中...</p>}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1001,
            }}
          >
            <div className="flex p-4">
              <img
                src="logo.jpg"
                alt="ロゴ"
                className="mx-auto rounded w-full"
              />
            </div>
            <div className="my-10">
              <p className="text-xl text-center font-bold">
                {process.env.REACT_APP_SYSTEM_NAME}
              </p>
            </div>
          </Spin>
        </div>
      </div>
    </>
  )
}

export default Login
